var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['pill', `pill--${_vm.variant}`]},[(_vm.icon)?_c('v-icon',{attrs:{"color":_vm.iconColor,"size":"14"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }